module.exports = __webpack_public_path__ + "static/media/rdsr_bg.830e4d23.png";